export default __webpack_public_path__ + "static/media/shape1.2add41b3.svg";